import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '@auth/services/authentication.service';
import { environment } from '../../../environments/environment';

export const CatchRefreshTokenErrorInterceptor: HttpInterceptorFn = (
  req,
  next,
) => {
  const _authenticationService = inject(AuthenticationService);
  if (req.url === environment.authentication.silentRenewUrl) {
    // Intercept the request and proceed with it.
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        console.warn('CATCH ERROR: ', error);
        if (error instanceof HttpErrorResponse && error.status === 400) {
          const refreshTokenExpired = new Date();
          localStorage.setItem(
            'refreshTokensessionEndedAt',
            refreshTokenExpired.toString(),
          );
          _authenticationService.logout();
        }

        // Return a new HttpErrorResponse with the modified error message.
        return throwError(() => {
          const httpResponse = {
            error: 'Session expired',
            status: 400,
            statusText: 'Bad Request',
          };
          return httpResponse;
        });
      }),
    );
  } else {
    //No modification for other requests.
    return next(req);
  }
};
